<template>
  <div v-if="globalStore.settings.isAppLoading" class="loading-container">
    <div class="loading-content">
      <img v-if="logoSrc" :src="logoSrc" alt="Logo" class="loading-logo" />
      <VaProgressCircle indeterminate thickness="0.3" size="large" />
    </div>
  </div>
  <div v-else>
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { useGlobalStore } from "@/stores/global-store"
import { computed } from "vue"
import { useI18n } from "vue-i18n"

const globalStore = useGlobalStore()
const { locale } = useI18n()

const logos = import.meta.glob("@/assets/culture/*.png", { eager: true, import: "default" })
const logoSrc = computed<string>((): string => {
  const path = `/src/assets/culture/${locale.value}.png`
  const src =
    (logos[path] as string | undefined) ?? (logos["/src/assets/culture/en-US.png"] as string | undefined) ?? ""
  return typeof src === "string" ? src : ""
})
</script>

<style lang="scss">
#app {
  font-family: "Inter", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}

.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  z-index: 9999;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.loading-logo {
  width: 500px;
  height: auto;
  margin-bottom: 1rem;
}
</style>
